import { SvgIcon } from '@mui/material'

// Types
import type { SvgIconProps } from '@mui/material'

// Plain mark without a circle, for places that already draw their own badge
const CrossIconAtom = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 24 24">
		<path fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" d="M7 7L17 17" />

		<path fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" d="M17 7L7 17" />
	</SvgIcon>
)

export default CrossIconAtom
